import { useEffect } from "react";
import { toast } from "sonner";
import useRevoiceJobs from "@/components/jammable/useRevoiceJobs";
import { markDelivered } from "@/lib/jammableApi";

const MAX_TAKES = 40;

/** Finished Jammable voice changes of this session's takes land as new takes on their track (same timing as the original). */
export default function useRevoiceTakes(session, busy) {
  const { doc, change, save } = session;
  const jobs = useRevoiceJobs(doc?.id ? { session_id: doc.id } : null, (job) => {
    if (job.kind !== "take" || job.delivered || !job.result?.file_url) return true;
    if (busy) return false;
    const take = { id: crypto.randomUUID(), file_url: job.result.file_url, name: `${job.take_name} · ${job.voice?.name}`.slice(0, 120),
      duration: job.result.duration || job.duration || 0, trim_head_sec: job.trim_head_sec || 0, start_sec: job.start_sec || 0, created_at: new Date().toISOString() };
    let added = false;
    change((d) => {
      const t = d.tracks.find((x) => x.id === job.track_id);
      if (!t || t.takes.length >= MAX_TAKES) return d;
      added = true;
      return { ...d, tracks: d.tracks.map((x) => (x.id === job.track_id ? { ...x, takes: [...x.takes, take] } : x)) };
    }, { reload: true });
    if (added) {
      save().then((ok) => ok && markDelivered(job.id).catch(() => {}));
      toast.success(`${take.name} is ready`, { description: "Added as a new take on the same track — pick it, stack it in the choir or send it to a song." });
    } else {
      markDelivered(job.id).catch(() => {});
      toast.error("A voice change finished, but its track is gone or full", { description: "It's still in your Recordings." });
    }
    return true;
  });
  const { refresh } = jobs;
  useEffect(() => { if (!busy) refresh(); }, [busy, refresh]);
  return jobs;
}
